export default __webpack_public_path__ + "static/media/jasmine.49531257.jpeg";